import React from "react";
import Copyright from "./footer/Copyright";
import Subscribe from "./footer/Subscribe";

const FooterTwo = () => {
  return (
    <div className="footer-area horizontal" id="support">
      <div className="footer-bg"></div>
      {/* <Subscribe /> */}
      <Copyright />
    </div>
  );
};

export default FooterTwo;
